// Account header component for the account page.

// Imports ----------------------------------------------------------------------------------------------------------

import Container from '@components/atoms/container/accountHeaderContainer';
import Title from '@components/atoms/text/accountTitle';
import Subtitle from '@components/atoms/text/accountSubtitle';
import TranslationManager from '@shared/assets/locale/translationsManager';
import { useMemo } from 'react';

// Constants ----------------------------------------------------------------------------------------------------------

const LITERALS = 'PAGES.SETTINGS.ACCOUNT';

/**
 * Account header component for the account page.
 * Displays the account title and subtitle.
 *
 * @returns {JSX.Element} Account header component
 */
export default function AccountHeader() {
  // Memoized values
  const { title, subtitle } = useMemo(() => {
    return {
      title: TranslationManager.get(`${LITERALS}.TITLE`),
      subtitle: TranslationManager.get(`${LITERALS}.INFO`),
    };
  }, []);

  // Render
  return (
    <Container>
      <Title>{title}</Title>
      <Subtitle>{subtitle}</Subtitle>
    </Container>
  );
}
